
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FilterPreset } from '@/types';

@Component
export default class SaveFilterPresetMenu extends Vue {
  @Prop({ required: true })
  presets!: FilterPreset<any>[];

  @Prop({ required: true })
  currentFilters!: object;

  menuOpen = false;
  dialogOpen = false;
  newPresetName = '';
  errorMessage = '';

  get nameRules() {
    return [
      (v: string) => !!v || 'Il nome è obbligatorio',
      (v: string) => v.length <= 50 || 'Il nome deve essere di massimo 50 caratteri',
    ];
  }

  onSaveExistingPreset(name: string) {
    this.menuOpen = false;
    this.$emit('save', { name, filters: this.currentFilters });
  }

  onSaveNewPreset() {
    this.menuOpen = false;
    this.dialogOpen = true;
    this.newPresetName = '';
    this.errorMessage = '';
  }

  cancelNewPreset() {
    this.dialogOpen = false;
    this.newPresetName = '';
    this.errorMessage = '';
  }

  saveNewPreset() {
    if (!this.newPresetName.trim()) {
      return;
    }

    // Verifica se esiste già un preset con lo stesso nome
    const existingPreset = this.presets.find((p: FilterPreset<any>) => p.name === this.newPresetName.trim());
    if (existingPreset) {
      this.errorMessage = 'Esiste già un preset con questo nome';
      return;
    }

    this.dialogOpen = false;
    this.$emit('save', {
      name: this.newPresetName.trim(),
      filters: this.currentFilters,
    });
    this.newPresetName = '';
    this.errorMessage = '';
  }
}
